import {
  IsArray,
  IsDefined,
  IsInt,
  IsISO8601,
  IsNotEmpty,
  IsNumber,
  IsOptional,
  Matches,
  ValidateNested
} from 'class-validator';
import { Type } from 'class-transformer';

export class StandAloneRefund {
  @IsOptional()
  @IsInt()
  orderId: number;

  @IsDefined()
  @IsNumber({maxDecimalPlaces: 2})
  amount: number;
}

export class StandAloneVoid {
  @IsOptional()
  @IsInt()
  voidId: number;

  @IsDefined()
  @IsNumber({maxDecimalPlaces: 2})
  amount: number;
}

export class StandAloneOrderItem {
  @IsDefined()
  @IsInt()
  menuId: number;

  @IsDefined()
  @IsInt()
  productId: number;

  @IsDefined()
  @IsInt()
  quantity: number;

  @IsDefined()
  @IsNumber({maxDecimalPlaces: 2})
  price: number;

  @IsOptional()
  @IsInt()
  vatRateId: number;

  @IsOptional()
  @IsNumber({maxDecimalPlaces: 2})
  vatRateValue: number;

  @IsOptional()
  @IsArray()
  @IsNotEmpty()
  @ValidateNested({each: true})
  @Type(() => StandAloneOrderItemModifier)
  orderItemModifiers?: StandAloneOrderItemModifier[];
}

export class StandAloneOrderItemModifier {
  @IsDefined()
  @IsInt()
  modifierId: number;

  @IsDefined()
  @IsInt()
  modifierGroupId: number;

  @IsDefined()
  @IsNumber({maxDecimalPlaces: 2})
  modifierPrice: number;
}

export class StandAloneOrderPayment {
  @IsOptional()
  @IsInt()
  id: number;

  @IsDefined()
  @IsInt()
  merchantPaymentMethodId: number;

  @IsDefined()
  @IsNumber({maxDecimalPlaces: 2})
  amount: number;
}

export class StandAloneOrderProductEntryDto {
  @IsOptional()
  @IsInt()
  orderId: number;

  @IsDefined()
  @IsISO8601()
  @Matches(/^\d{4}-\d{2}-\d{2}$/)
  date: string;

  @IsDefined()
  @IsInt()
  posDeviceId: number;

  @IsDefined()
  @IsInt()
  merchantId: number;

  @IsDefined()
  @IsInt()
  applicationSourceId: number;

  @IsOptional()
  @IsNumber({maxDecimalPlaces: 2})
  processingFee: number;

  @IsOptional()
  @IsNumber({maxDecimalPlaces: 2})
  discountAmount: number;

  @IsOptional()
  @IsNumber({maxDecimalPlaces: 2})
  serviceChargeAmount: number;

  @IsOptional()
  @Type(() => StandAloneRefund)
  refund: StandAloneRefund;

  @IsOptional()
  @Type(() => StandAloneRefund)
  voids: StandAloneVoid;

  @IsDefined()
  @IsArray()
  @ValidateNested({each: true})
  @Type(() => StandAloneOrderItem)
  insertOrderItems: StandAloneOrderItem[];

  @IsDefined()
  @IsArray()
  @IsNotEmpty()
  @ValidateNested({each: true})
  @Type(() => StandAloneOrderPayment)
  orderPayments: StandAloneOrderPayment[];
}

export class StandAloneOrderSalesEntryDto {
  @IsOptional()
  @IsInt()
  orderId: number;

  @IsDefined()
  @IsISO8601()
  @Matches(/^\d{4}-\d{2}-\d{2}$/)
  date: string;

  @IsDefined()
  @IsInt()
  posDeviceId: number;

  @IsDefined()
  @IsInt()
  merchantId: number;

  @IsDefined()
  @IsInt()
  applicationSourceId: number;

  @IsOptional()
  @IsNumber({maxDecimalPlaces: 2})
  processingFee: number;

  @IsOptional()
  @IsNumber({maxDecimalPlaces: 2})
  discountAmount: number;

  @IsOptional()
  @IsNumber({maxDecimalPlaces: 2})
  serviceChargeAmount: number;

  @IsOptional()
  @Type(() => StandAloneRefund)
  refund: StandAloneRefund;

  @IsOptional()
  @Type(() => StandAloneRefund)
  voids: StandAloneVoid;

  @IsDefined()
  @IsNumber({maxDecimalPlaces: 2})
  total: number;

  @IsDefined()
  @IsNumber({maxDecimalPlaces: 2})
  vat: number;

  @IsDefined()
  @IsArray()
  @IsNotEmpty()
  @ValidateNested({each: true})
  @Type(() => StandAloneOrderPayment)
  orderPayments: StandAloneOrderPayment[];
}